import React, { Component } from "react";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Save from '../../../assets/img/svg/save.svg';
import Delete from '../../../assets/img/svg/delete.svg';
import Ship from '../../../assets/img/svg/Ship.svg';
import { render } from "@testing-library/react";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Grid, Card, Typography, Divider, CardContent, Container, Box, Tooltip } from "@material-ui/core";
import { getprojectbasicinfo } from "../../../actions/AddNewProjectAction";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../assets/jss/customStyle"
import $ from "jquery"
import moment from "moment"
import axios from "axios";
import API from "../../../_helpers/endpointService"
import { getSettingsFormat } from "../../../actions/SettingsAction"

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ProjectId: 0,
            isMobile: false,
            isEdit: false,
            menu: true,
            dashboarddata: "",
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Dashboard1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Dashboard").removeClass("d-none");
        $("#Dashboard").addClass("d-block");
    };

    componentDidMount() {
        this.state.ProjectId = localStorage.getItem("DashId")
        this.setState({})
        this.props.dispatch(getprojectbasicinfo(this.state.ProjectId))
        this.getProjectDashBoard(this.state.ProjectId)
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    };

    getProjectDashBoard = (id) => {
        let apiUrl = API.DASHBOARD_DETAILS + id
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.dashboarddata = response?.data;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };


    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { isMobile, dashboarddata } = this.state;
        return (<>
            {
                this.state.isMobile ?
                    <>
                        <div className="row w-100 border-bottom mt-4">
                            <div className="col-5 w-50 mt-auto">
                                <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem onClick={this.sidebar} >
                                        <ListItemText id={"Dashboard" + "1"} className='textNaviIcon' primary="Dashboard" />
                                        <NavigateNextIcon id="Dashboard" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                        <Divider className='border-bottom' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-7 pt-2 mt-5 w-50 ">
                                <h4 className="pt-2">Ship Particulars</h4>
                            </div>
                        </div>
                    </>
                    :
                    <></>
            }
            <div className="pt-2 ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: "100%", marginTop: this.state.isMobile ? 8 : -95 }}>
                <div className="container-fluid">
                    <div className="row px-4">
                        <div className="col-12 pt-4">
                            {isMobile ? <></> : <h6>Ship Particulars</h6>}
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Name of Ship:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.Name}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Ship Type:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.Type}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Flag state & Port of registry:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.PortOfRegistry}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Ship builder:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.Builder}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Ship Owner:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipOwner}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Year of construction:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.ConstructionDate && moment(dashboarddata?.ShipParticualrsDTO?.ConstructionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Classification society:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.ClassificationSociety}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Gross tonnage:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.GrossTonnage}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Net tonnage:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.NetTonnage}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Light ship weight:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.LightShipWeight}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Length overall:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.Length}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Breadth:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.Breath}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Depth:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.Depth}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Design Draught:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.DesignDraught}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">IMO number:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.IMONumber}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Distinctive number or letters:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.DistinctiveNumber}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4 pr-0 mr-0">
                            <label className="dashques">IMO-registered owner identification Number:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.IMORegisteredOwnerId}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4 pr-0">
                            <label className="dashques">IMO company identification Number:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.IMOCompanyId}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Telephone number:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.PhoneNumber}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">E-mail address:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.Email}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Date of Beaching:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.DateofBeaching && moment(dashboarddata?.ShipParticualrsDTO?.DateofBeaching).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</label>
                        </div>
                        <div className="col-12 pt-4">
                            <h6>Status</h6>
                        </div>
                        <div className="col-12 col-sm-12 col-lg-12 col-xl-12 pt-4">
                            <img src={dashboarddata?.Drawing?.FileUrl && dashboarddata?.Drawing?.FileUrl} style={{ width: "100%", height: "300px" }} />
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Lightship Tonnage:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.ShipParticualrsDTO?.LightShipWeight}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Dismantled Tonnage:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.DismantledTonnage}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Dismantled %:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.TonnagePercent}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Total No. of Finding during Initial Audit:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.TotalFindingsIntialAudit}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Total No. of Daily Obervations:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.DailyObservationTotal}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Total recorded investigation (NM/Incident):	</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.TotalInvestigationRecord}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Number of Findings closed:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.TotalFindingsClosed}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Number of Observations Closed:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.DailyObservationClosed}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashques">Near Miss:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4">
                            <label className="dashans">{dashboarddata?.NearMiss}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4 pb-4">
                            <label className="dashques">Number of Findings open:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4 pb-4">
                            <label className="dashans">{dashboarddata?.TotalFindingsOpened}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4 pb-4">
                            <label className="dashques">Number of Obervations open:	</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4 pb-4">
                            <label className="dashans">{dashboarddata?.DailyObservationOpened}</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4 pb-4">
                            <label className="dashques">Incidents:</label>
                        </div>
                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 pt-4 pb-4">
                            <label className="dashans">{dashboarddata?.Incident}</label>
                        </div>
                    </div>
                </div>
            </div>
        </>);
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        Format: state.AddNewProjectReducer.Format || [],
        settings: state.commonReducer.settings || [],
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Dashboard))
);
